import {
  ChargeMethodEnum,
  OrganizationId,
  type PackageDomainSelectModel,
  PackageId,
  type ProjectDomainSelectModel,
  ProjectId,
  ProjectKey,
  ProjectStatuses,
  ProjectUrn,
  type ProjectViewDomainSelectModel,
  TeamId,
  UserId,
} from '@mntn-dev/domain-types'
import { calculateCostPlusMargin } from '@mntn-dev/finance-utilities'
import { generateFormattedText, getRandomItem } from '@mntn-dev/utilities'

import { MockModel } from './mock-model.ts'
import { MockPackage } from './mock-package.ts'

export const MockProjectInheritedProperties = ({
  package: {
    name,
    description,
    cost,
    costPlusMargin,
    packageSource: source,
    packageFormat: format,
    translations,
  },
}: {
  package: PackageDomainSelectModel
}): ProjectDomainSelectModel['inherited'] => {
  return {
    package: {
      name,
      description,
      cost,
      costPlusMargin,
      source,
      format,
      translations,
    },
  }
}

export const MockProject = MockModel<ProjectViewDomainSelectModel>(
  ({
    projectId = ProjectId(),
    projectUrn = ProjectUrn(projectId),
    name = `Project ${projectId}`,
    description = generateFormattedText(`Project Description ${projectId}`),
    ownerId = UserId(),
    brandOrganizationId = OrganizationId(),
    brandTeamId = TeamId(),
    status = getRandomItem(ProjectStatuses),
    costMarginPercent = 50,
    packageId = PackageId(),
    inherited = MockProjectInheritedProperties({
      package: MockPackage({ packageId, costMarginPercent }),
    }),
    cost = inherited.package.cost,
    costPlusMargin = cost && calculateCostPlusMargin(cost, costMarginPercent),
    brandCompanyName = `Brand ${brandTeamId}`,
    lastTouchedTimestamp = new Date(),
    billingSchedule = '100_up_front',
    invoiceTerms = 'none',
    billingMethods = [ChargeMethodEnum.invoice, ChargeMethodEnum.stripe],
    chosenBillingMethod = ChargeMethodEnum.stripe,
    currency = 'USD',
  }) => {
    return {
      projectId,
      projectKey: ProjectKey(),
      projectUrn,
      name,
      description,
      ownerId,
      brandOrganizationId,
      brandTeamId,
      status,
      packageId,
      inherited,
      cost,
      costMarginPercent,
      costPlusMargin,
      brandCompanyName,
      lastTouchedTimestamp,
      billingSchedule,
      invoiceTerms,
      billingMethods,
      chosenBillingMethod,
      currency,
    } satisfies ProjectViewDomainSelectModel
  }
)
